module.exports = __webpack_public_path__ + "img/chi-spacca.b6b97e9b.jpg";